
import SyncServices from '../providers/SyncServices';
import { SYNC_SERVICE } from '../global/Constants';
import Utilities from '../global/Utilities';

export default class DataProvider {

    static mInstance = null;

    crops = [];
    hybrids = [];
    hybridLocationTehsil = [];
    userLocations = [];
    villages = [];
    tehsils = [];
    seasons = [];
    subActivities = [];
    retailers = [];
    quantityGivens = [];
    competitorHybrids = [];
    weightUnits = [];
    employees = [];
    sampleTypes = [];
    rejectReasons = [];
    irrigationTypes = [];
    spacings = [];
    stages = [];
    cropHealths = [];
    rowDistances = [];
    fieldDamageReasons = [];
    fieldDayManagers = [];
    sampleToSaleCrop = [];
    userCrops = [];
    cropGroups = [];
    levels = [];
    dakshCompetitorHybrids = [];
    cropSeasonSubActivities = [];

    notificationCount = 0;

    static getInstance() {
        if (DataProvider.mInstance == null) {
            DataProvider.mInstance = new DataProvider();
        }
        return this.mInstance;
    }

    async fetchMasterData() {
        await SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_CROP, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("fetchMasterData crops:", data);
            this.crops = data;
        });

        await SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_HYBRID, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("fetchMasterData hybrids:", data);
            this.hybrids = data;
        });

        await SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_HYBRID_LOCATION_TEHSIL, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("fetchMasterData hybridLocationTehsil:", data);
            this.hybridLocationTehsil = data;
        });

        await SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_USER_LOCATION, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("fetchMasterData userLocations:", data);
            this.userLocations = data;
        });

        await SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_VILLAGE, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("fetchMasterData villages:", data);
            this.villages = data;
        });

        // For Tehsils
        await SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_TEHSIL, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("fetchMasterData Tehsils:", data);
            this.tehsils = data;
        });

        await SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_SEASON, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("fetchMasterData seasons:", data);
            this.seasons = data;
        });

        await SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_SUB_ACTIVITY, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("fetchMasterData subActivities:", data);
            this.subActivities = data;
        });

        await SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_RETAILER, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("fetchMasterData retailers:", data);
            this.retailers = data;
        });

        await SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_QUALITY_GIVEN, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("fetchMasterData quantityGivens:", data);
            this.quantityGivens = data;
        });

        // For Competitor Hybrid
        await SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_COMPETITOR_HYBRID, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("fetchMasterData competitorHybrids:", data);
            this.competitorHybrids = data;
        });

        // For Daksh Competitor Hybrid
        await SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_DAKSH_COMPETITOR_HYBRID, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("fetchMasterData competitorHybrids:", data);
            this.dakshCompetitorHybrids = data;
        });

        // For Weight Unit
        await SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_WEIGHT_UNIT, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("fetchMasterData competitorHybrids:", data);
            this.weightUnits = data;
        });

        // For Employee
        await SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_EMPLOYEE, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("fetchMasterData employees:", data);
            this.employees = data;
        });

        // For Type Of Samples
        await SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_TYPE_OF_SAMPLE, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("fetchMasterData sampleTypes:", data);
            this.sampleTypes = data;
        });

        // For Activity Reject Reasons
        await SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_REJECT, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("fetchMasterData sampleTypes:", data);
            this.rejectReasons = data;
        });

        // For Irrigation Types
        await SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_IRRIGATION_SOURCE, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("fetchMasterData irrigationTypes:", data);
            this.irrigationTypes = data;
        });

        // For Crop Sowing Spacing
        await SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_CROP_SOWING_SPACING, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("fetchMasterData sowing spacings:", data);
            this.spacings = data;
        });

        // For Plot Visit Stages
        await SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_CROP_DAYS, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("fetchMasterData stages:", data);
            this.stages = data;
        });

        // For Crop Healths
        await SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_CROP_PLOT_VISIT_CROP_HEALTH, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("fetchMasterData cropHealths:", data);
            this.cropHealths = data;
        });

        // For Row Distances
        await SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_ROW_DISTANCE, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("fetchMasterData cropHealths:", data);
            this.rowDistances = data;
        });

        // For Field Damage Reasons
        await SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_FIELD_DAMAGE_REASON, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("fetchMasterData cropHealths:", data);
            this.fieldDamageReasons = data;
        });

        // Field Day Managers
        await SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_FIELD_DAY_MANAGER, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("fetchMasterData cropHealths:", data);
            this.fieldDayManagers = data;
        });

        // Levels
        await SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_LEVEL, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("fetchMasterData levels:", data);
            this.levels = data;
        });


        // Sample To Sale Crop
        await SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_SAMPLE_TO_SALE_CROP, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("fetchMasterData cropHealths:", data);
            this.sampleToSaleCrop = data;
        });

        // Crop Groups
        await SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_CROP_GROUP, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("fetchMasterData cropHealths:", data);
            this.cropGroups = data;
        });


        // User Crops
        await SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_USER_CROP, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("fetchMasterData cropHealths:", data);
            this.userCrops = data;
        });

        // Crop Season Sub Activity
        await SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_CROP_SEASON_SUB_ACTIVITY, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("fetchMasterData cropSeasonSubActivities:", data);
            this.cropSeasonSubActivities = data;
        });
    }

    getCrops = () => {
        return this.crops;
    }

    getHybrids = () => {
        return this.hybrids;
    }

    getVillages = () => {
        return this.villages;
    }

    getHybridLocationTehsil = () => {
        return this.hybridLocationTehsil;
    }

    getUserLocations = () => {
        return this.userLocations;
    }

    getTehsils = () => {
        return this.tehsils;
    }

    getCropNameById = (cropId) => {
        if (this.crops.length > 0) {
            const crop = this.crops.find(item => item.crop_id === cropId);
            //Utilities.LogPrint("getCropNameById", crop);
            if (crop && crop !== null) {
                return crop?.crop_name;
            }
        }
        return "";
    }

    getHybridNameById = (hybridId) => {
        if (this.hybrids.length > 0) {
            let hybrid = this.hybrids.find(item => item.hybrid_id === hybridId);
            //Utilities.LogPrint("getHybridNameById", hybrid);
            if (hybrid && hybrid !== null) {
                return hybrid?.season_name;
            }
        }
        return "";
    }

    getVillageNameById = (villageId) => {
        if (this.villages.length > 0) {
            let village = this.villages.find(item => item.village_id === villageId);
            //Utilities.LogPrint("getVillageNameById", village);
            if (village && village !== null) {
                return village?.village_name;
            }
        }
        return "";
    }

    getCropById = (cropId) => {
        if (this.crops.length > 0) {
            const crop = this.crops.find(item => item.crop_id === cropId);
            //Utilities.LogPrint("getCropById", crop);
            if (crop && crop !== null) {
                return crop;
            }
        }
        return "";
    }

    getSeasons = () => {
        const seasonsArray = this.seasons.filter(item => {
            return item.is_active === 1;
        });
        return seasonsArray;
    }

    getSeasonById = (seasonId) => {
        if (this.seasons.length > 0) {
            const season = this.seasons.find(item => item.season_id === seasonId);
            Utilities.LogPrint("season", season);
            return season;
        }
    }

    getSubActivities = (activityTypeId, seasonId, cropId) => {
        if (this.subActivities.length > 0) {
            const subActivities = this.subActivities.filter(item => {
                return (item.activity_type_id === activityTypeId &&
                    item.season_id === seasonId &&
                    item.crop_id === cropId &&
                    item.is_active === 1);
            });
            Utilities.LogPrint("subActivities", subActivities);
            return subActivities;
        }
    }

    getSubActivitiesById = (subActivityId) => {
        if (this.subActivities.length > 0) {
            const subActivity = this.subActivities.find(item => item.sub_activity_id === subActivityId);
            Utilities.LogPrint("subActivity", subActivity);
            return subActivity;
        }
    }

    getRetailers = () => {
        return this.retailers;
    }

    getQuantityGivens = () => {
        if (this.quantityGivens.length > 0) {
            this.quantityGivens.forEach(element => {
                const weightUnit = this.weightUnits?.find(item => item.weight_unit_id === element.weight_unit_id);
                if (weightUnit) {
                    element.weight_unit_name = weightUnit?.name;
                }
            });
            return this.quantityGivens;
        }
    }

    getCompetitorHybrids = () => {
        return this.competitorHybrids;
    }

    getDakshCompetitorHybrids = () => {
        return this.dakshCompetitorHybrids;
    }

    getCompetitorHybrid = (hybridId) => {
        if (this.competitorHybrids.length > 0) {
            const hybrids = this.competitorHybrids.filter(item => {
                return (item.hybrid_id === hybridId);
            });
            Utilities.LogPrint("hybrids", hybrids);
            return hybrids;
        }
    }


    getEmployeeById = (userId) => {
        if (this.employees.length > 0) {
            const employee = this.employees.find(item => item.user_id === userId);
            Utilities.LogPrint("employee", employee);
            return employee;
        }
    }

    getTypeOfSamples = () => {
        if (this.sampleTypes.length > 0) {
            return this.sampleTypes;
        }
    }


    getRejectReasons = (activityTypeId) => {
        if (this.rejectReasons.length > 0) {
            const rejectReasons = this.rejectReasons.filter(item => {
                return (item.activity_type_id === activityTypeId);
            });
            Utilities.LogPrint("rejectReasons", rejectReasons);
            return rejectReasons;
        }
    }

    getIrrigationTypes = () => {
        if (this.irrigationTypes.length > 0) {
            const irrigationTypes = this.irrigationTypes.filter(item => {
                return (item.is_active === 1);
            });
            Utilities.LogPrint("irrigationTypes", irrigationTypes);
            return irrigationTypes;
        }
        return this.irrigationTypes;
    }

    getSpacingTypes = (cropId) => {
        if (this.spacings.length > 0) {
            const spacings = this.spacings.filter(item => {
                return (item.crop_id === cropId && item.is_active === 1);
            });
            Utilities.LogPrint("spacings", spacings);
            return spacings;
        }
        return this.spacings;
    }

    getPlotVisitStages = () => {
        return this.stages;
    }

    getCropHealths = () => {
        return this.cropHealths;
    }

    getRowDistances = () => {
        if (this.rowDistances.length > 0) {
            const rowDistances = this.rowDistances.filter(item => {
                return (item.is_active === 1);
            });
            Utilities.LogPrint("rowDistances", rowDistances);
            return rowDistances;
        }
        return this.rowDistances;
    }

    getFieldDamageReasons = () => {
        if (this.fieldDamageReasons.length > 0) {
            const fieldDamageReasons = this.fieldDamageReasons.filter(item => {
                return (item.is_active === 1);
            });
            Utilities.LogPrint("fieldDamageReasons", fieldDamageReasons);
            return fieldDamageReasons;
        }
        return this.fieldDamageReasons;
    }

    getFieldDayManagers = () => {
        if (this.fieldDayManagers.length > 0) {
            const fieldDayManagers = this.fieldDayManagers.filter(item => {
                return (item.is_active === 1);
            });
            Utilities.LogPrint("fieldDayManagers", fieldDayManagers);
            return fieldDayManagers;
        }
        return this.fieldDayManagers;
    }

    getSampleToSaleCrop = () => {
        return this.sampleToSaleCrop;
    }

    getCropGroups = () => {
        return this.cropGroups;
    }



    getUserCrops = () => {
        if (this.userCrops.length > 0) {
            const userCrops = this.userCrops.filter(item => {
                return (item.is_active === 1);
            });
            Utilities.LogPrint("userCrops", userCrops);
            return userCrops;
        }
        return this.userCrops;
    }

    getLevels = () => {
        return this.levels;
    }



    getCropSeasonSubActivities = (cropId, activityTypeId) => {
        if (this.cropSeasonSubActivities.length > 0) {

            const cropData = this.cropSeasonSubActivities.find(item => item.crop_id === cropId);
            if (!cropData) return [];

            const activityData = cropData.activity_type.find(item => item.activity_type_id === activityTypeId);
            if (!activityData) return [];


            Utilities.LogPrint("cropSeasonSubActivities", activityData?.season);
            return activityData?.season ?? [];

            // const data = this.cropSeasonSubActivities.find(item => {
            //     return (item.crop_id === cropId);
            // });
            // Utilities.LogPrint("cropSeasonSubActivities", JSON.stringify(data));
            // return data;
        }
        return this.cropSeasonSubActivities;
    }



    //For Local Manage 
    getGerminationLists = () => {
        const germinationLists = [
            { value: 0, label: "Good (> 80%)" },
            { value: 1, label: "Average (79% to 50%)" },
            { value: 2, label: "Poor (< 50%)" }
        ]
        return germinationLists;
    }

    getFruitUniformity = () => {
        const fruitUniformities = [
            { value: 1, label: "Good" },
            { value: 2, label: "Average" },
            { value: 3, label: "Poor" }
        ]
        return fruitUniformities;
    }


    setNotificationCount = (count) => {
        this.notificationCount = count;
    }

    getNotificationCount = () => {
        return this.notificationCount;
    }
}
